export const LOGIN_STATUS = {
  IDLE: 'IDLE',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  UNAUTHORIZED: 'UNAUTHORIZED',
}
